var _defs, _rect, _circle, _circle2, _g, _text, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSfadminagent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    role: "img",
    "aria-label": "SF Admin Agent",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b1055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55198b"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 70,
    r: 130,
    fill: "#8c43ce",
    opacity: 0.35
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 320,
    r: 100,
    fill: "#2196f3",
    opacity: 0.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60,96)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 150,
    height: 150,
    rx: 26,
    fill: "#ffffff",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 134,
    height: 134,
    rx: 20,
    fill: "#ffffff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 92,
    textAnchor: "middle",
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 58,
    fontWeight: 800,
    fill: "#ffffff"
  }, "\uD83E\uDD16"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 150,
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 40,
    fontWeight: 800,
    fill: "#ffffff"
  }, "SF Admin Agent")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 196,
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 21,
    fill: "#d9c8f0"
  }, "AI-powered virtual Salesforce admin")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 232,
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 21,
    fill: "#d9c8f0"
  }, "driven by the Claude API")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSfadminagent);
export default __webpack_public_path__ + "static/media/sfadminagent.c28133edaaf01d09054bc9aa3742611c.svg";
export { ForwardRef as ReactComponent };